import { NotificationType, type StaticNotification } from './types'

export const staticNotifications: StaticNotification = {
  [NotificationType.SAVE_PROJECT_SUCCESS]: {
    type: 'topaz',
    text: 'Project saved',
    toastContainerId: 'secondary',
  },
  [NotificationType.LIMIT_REACHED]: {
    type: 'coral',
    text: 'Space project limit reached',
    toastContainerId: 'secondary',
  },
  [NotificationType.FIGMA_ACCOUNT_OWNER]: {
    type: 'coral',
    text: 'Please ask project owner to enable Figma',
    toastContainerId: 'secondary',
  },
  [NotificationType.FIGMA_ACCOUNT_ADMIN]: {
    type: 'coral',
    text: 'Please ask team account admin to enable Figma',
    toastContainerId: 'secondary',
  },
  [NotificationType.MODAL_LINK_COPY_SUCCESS]: {
    type: 'gray',
    text: 'URL address copied to clipboard',
    toastContainerId: 'secondary',
  },
  [NotificationType.MODAL_LINK_COPY_LOCKED_SUCCESS]: {
    type: 'gray',
    text: 'Block URL copied to clipboard. Public access is closed and only invited users will be able to follow the link.',
    toastContainerId: 'secondary',
  },
  [NotificationType.SOMETHING_WENT_WRONG_ERROR]: {
    type: 'coral',
    text: 'Something went wrong...',
    toastContainerId: 'secondary',
  },
  [NotificationType.PROBLEM_WITH_SAVING_CHANGES]: {
    type: 'coral',
    text: 'Problem with saving changes.',
    toastContainerId: 'secondary',
  },
  [NotificationType.SAVE_FAILED]: {
    type: 'coral',
    text: "Changes can't be saved. Reload the page to continue.",
    actionText: 'Reload',
    toastContainerId: 'socket',
  },
  [NotificationType.TEAM_REQUEST_ERROR]: {
    type: 'coral',
    text: 'Something went wrong...',
    toastContainerId: 'secondary',
  },
  [NotificationType.UPDATE_PASSWORD_SUCCESS]: {
    type: 'topaz',
    text: 'Password updated successfully',
    toastContainerId: 'secondary',
  },
  [NotificationType.RESET_PASSWORD_SUCCESS]: {
    type: 'topaz',
    text: 'New password successfully saved',
    toastContainerId: 'secondary',
  },
  [NotificationType.RESET_PASSWORD_ERROR]: {
    type: 'coral',
    text: 'Something went wrong while saving new password',
    toastContainerId: 'secondary',
  },
  [NotificationType.PASSWORD_PROTECTED_SUCCESS]: {
    type: 'topaz',
    text: 'Password protected successfully',
    toastContainerId: 'secondary',
  },
  [NotificationType.ACCESS_SETTINGS_UPDATED]: {
    type: 'topaz',
    text: 'Access settings updated',
    toastContainerId: 'secondary',
  },
  [NotificationType.PASSWORD_PROTECTED_EMPTY]: {
    type: 'coral',
    text: 'Password can not be empty',
    toastContainerId: 'secondary',
  },
  [NotificationType.PASSWORD_PROTECTED_ERROR]: {
    type: 'coral',
    text: 'Something went wrong',
    toastContainerId: 'secondary',
  },
  [NotificationType.PASSWORD_PROTECTED_PASSWORD_ERROR]: {
    type: 'coral',
    text: 'The password you entered is incorrect. Please try again.',
    toastContainerId: 'secondary',
  },
  [NotificationType.PROFILE_UPDATED]: {
    type: 'topaz',
    text: 'Profile successfully updated',
    toastContainerId: 'secondary',
  },
  [NotificationType.CONNECTING]: {
    type: 'gray',
    text: 'Connecting...',
    toastContainerId: 'socket',
  },
  [NotificationType.FETCHING]: {
    type: 'gray',
    text: 'Fetching project updates…',
    toastContainerId: 'socket',
  },
  [NotificationType.AI_GENERATING]: {
    type: 'ai',
    text: 'AI generating...',
    toastContainerId: 'ai',
    actionText: 'Stop',
  },
  [NotificationType.AI_FINISHED]: {
    type: 'topaz',
    text: 'Generation complete',
    toastContainerId: 'ai',
  },
  [NotificationType.THANK_YOU]: {
    type: 'topaz',
    text: 'Thank you!',
    toastContainerId: 'secondary',
  },
  [NotificationType.OFFLINE]: {
    type: 'coral',
    text: "You're offline. Check your internet connection.",
    actionText: 'Click to reconnect',
    toastContainerId: 'socket',
  },
  [NotificationType.ONLINE]: {
    type: 'topaz',
    text: '',
    toastContainerId: 'socket',
  },
  [NotificationType.COPY_SUCCESS]: {
    type: 'topaz',
    text: 'Copied to clipboard',
    toastContainerId: 'secondary',
  },
  [NotificationType.COPY_FAILED]: {
    type: 'coral',
    text: 'Copy failed',
    toastContainerId: 'secondary',
  },
  [NotificationType.READ_ONLY_VIEW]: {
    type: 'orange-opacity',
    text: 'Viewing in read-only mode',
    toastContainerId: 'main',
  },
  [NotificationType.ACTIVITY_HISTORY_PREVIEW]: {
    type: 'orange',
    text: 'Read-only view. Restore this version for editing.',
    toastContainerId: 'main',
    actionText: 'Restore',
  },
  [NotificationType.ARROW_MODE]: {
    type: 'topaz-opacity',
    text: 'Click on another page to create an arrow',
    toastContainerId: 'main',
  },
  [NotificationType.SYMBOL_SELECTED]: {
    type: 'symbol',
    text: 'Symbol selected. Copy / Paste to other pages',
    toastContainerId: 'main',
  },
  [NotificationType.INVITATION_SENT]: {
    type: 'topaz',
    text: 'Invite successfully sent',
    toastContainerId: 'secondary',
  },
  [NotificationType.FIGMA_FILE_NOT_FOUND]: {
    type: 'coral',
    text: 'File not found',
    toastContainerId: 'secondary',
  },
  [NotificationType.TARGET_PAGE_COLLAPSED]: {
    type: 'gray',
    text: 'Target page is collapsed',
    toastContainerId: 'main',
    actionText: 'Expand',
  },
  [NotificationType.DEBUG_MODE]: {
    type: 'coral',
    text: 'DEBUG MODE',
    toastContainerId: 'main',
    actionText: 'Close',
  },
  [NotificationType.UPLOAD_ERROR]: {
    type: 'coral',
    text: 'Upload error. Please use PNG, JPG or GIF.',
    toastContainerId: 'main',
  },
  [NotificationType.UPLOAD_ATTACHMENT_FILE_ERROR]: {
    type: 'coral',
    text: 'An error occurred while the file uploading.',
    toastContainerId: 'main',
  },
  [NotificationType.MAX_SIZE_ATTACHMENT_FILE_ERROR]: {
    type: 'coral',
    text: 'File size exceeds the maximum limit of 250 mb.',
    toastContainerId: 'main',
  },
  [NotificationType.RENAME_ERROR]: {
    type: 'coral',
    text: `Project name can't be empty.`,
    toastContainerId: 'main',
  },
  [NotificationType.PAGE_COPIED]: {
    type: 'gray',
    text: `Page copied`,
    toastContainerId: 'secondary',
  },
  [NotificationType.TREE_COPIED]: {
    type: 'gray',
    text: `Tree copied`,
    toastContainerId: 'secondary',
  },
  [NotificationType.SYMBOL_EDITING]: {
    type: 'symbol',
    text: `Symbol editing`,
    toastContainerId: 'main',
  },
  [NotificationType.SYMBOL_REPLACEMENT_DONE]: {
    type: 'topaz',
    text: `Linked symbols updated`,
    toastContainerId: 'secondary',
  },
  [NotificationType.COPY_SUCCESSFUL]: {
    type: 'gray',
    text: 'Copied',
    toastContainerId: 'secondary',
  },
  [NotificationType.LINKED_PAGE_IS_OPEN]: {
    type: 'gray',
    text: "You're on the linked page",
    toastContainerId: 'secondary',
  },
  [NotificationType.PAGE_NOT_FOUND]: {
    type: 'gray',
    text: "Page can't be found",
    toastContainerId: 'secondary',
  },
}
